import { type TooltipProps } from '@mui/material'

import { InfoTooltip } from './InfoTooltip'

export function MultipleChoiceTooltips({
  children,
  placement,
}: {
  children: React.ReactElement<any, any>
  placement?: TooltipProps['placement']
}) {
  return (
    <InfoTooltip placement={placement} title="Students select the correct answer from a list of options.">
      {children}
    </InfoTooltip>
  )
}
